export default "__VITE_ASSET__90326f40__"